<div class="note-card">
    <div class="note-card-title">{{ note.title }}</div>
    <div class="note-card-content" *ngIf="note.content">{{ note.content }}</div>
</div>